import isNil from 'lodash-es/isNil';

import { ThunkResult } from 'app/store/helpers';
import { TagManagerService } from 'app/services/tagManager.service';
import { getQuotationNumber } from 'app/store/data/quotation';
import { OfferInterface } from 'app/shared/interfaces/Offer.interface';
import { ReturnDataLayerEventInterface } from 'app/shared/interfaces/ReturnDataLayerEvent.interface';
import { getOffer } from 'app/store/data/quotationResult';

export const addBackToCalculationDataLayerEvent = (): ThunkResult => (
  dispatch,
  getState
) => {
  const state = getState();
  const quotationNumber = getQuotationNumber(state);

  const dataLayer = {
    event: 'zmien_dane_click',
    numer_porownania: quotationNumber,
  };

  TagManagerService.addDataLayer(dataLayer);
};

export const addReturnDataLayerEvent = ({
  eventName,
  elementName,
  eventLocation,
  stepName,
}: ReturnDataLayerEventInterface): ThunkResult => (dispatch, getState) => {
  const state = getState();
  const quotationNumber = getQuotationNumber(state);

  const dataLayer = {
    event: eventName,
    element_name: elementName,
    lokalizacja: eventLocation,
    step_name: stepName,
    numer_porownania: quotationNumber,
  };

  TagManagerService.addDataLayer(dataLayer);
};

export const addCalculationPageDataLayerEvent = ({
  eventName,
  offerId,
  isRecommended,
  elementText,
  index,
  sposob_sortowania,
  filter_name,
  filter_value,
  anyFilterSelected,
  eventLocation,
}: {
  eventName: string;
  offerId?: OfferInterface['id'];
  isRecommended?: boolean;
  elementText?: string;
  index?: string;
  sposob_sortowania?: string;
  filter_name?: string;
  filter_value?: string;
  anyFilterSelected?: boolean;
  eventLocation?: string;
}): ThunkResult => (dispatch, getState) => {
  const state = getState();
  const quotationNumber = getQuotationNumber(state);

  let dataLayerDetails;

  if (offerId) {
    const offer = getOffer(offerId)(state);
    const offerType = isRecommended ? 'rekomendowana' : 'nierekomendowana';
    dataLayerDetails = {
      eventLabel: offer?.insurerName || '',
      numerOferty: offer?.number || '',
      typOferty: offerType,
    };
  } else {
    dataLayerDetails = {
      eventLabel: 'widget',
      numerOferty: 'widget',
      typOferty: 'widget',
    };
  }

  TagManagerService.addDataLayer({
    event: eventName,
    eventCategory: 'strona_kalkulacji',
    eventAction: eventName,
    numerPorownania: quotationNumber,
    ...dataLayerDetails,
    ...(elementText && { elementText }),
    ...(index && { index }),
    ...(sposob_sortowania && { sposob_sortowania }),
    ...(filter_name && { filter_name }),
    ...(filter_value && { filter_value }),
    ...(!isNil(anyFilterSelected) && { anyFilterSelected }),
    ...(eventLocation && { lokalizacja: eventLocation }),
  });
};
